import React, { useMemo } from "react";

export const plotCoordinates = [
   { "id": "plot-1", "coords": "1802,2764, 1825,2958, 1939,2942, 1912,2749", "alt": "Plot - 1" },
  { "id": "plot-2", "coords": "1915,2750, 1944,2942, 2158,2914, 2125,2699, 2084,2707, 2084,2725", "alt": "Plot - 2" },
  { "id": "plot-3", "coords": "2130,2703, 2162,2910, 2339,2888, 2304,2674", "alt": "Plot - 3" },
  { "id": "plot-4", "coords": "2342,2674, 2377,2879, 2585,2854, 2540,2646", "alt": "Plot - 4" },
  { "id": "plot-5", "coords": "2544,2646, 2587,2851, 2702,2832, 2664,2629", "alt": "Plot - 5" },
  { "id": "plot-6", "coords": "2671,2632, 2704,2832, 2885,2810, 2835,2604", "alt": "Plot - 6" },
  { "id": "plot-7", "coords": "2839,2605, 2890,2806, 3031,2795, 2998,2582", "alt": "Plot - 7" },
  { "id": "plot-8", "coords": "1821,2960, 1841,3151, 1960,3142, 1942,2946", "alt": "Plot - 8" },
  { "id": "plot-9", "coords": "1947,2945, 1965,3140, 2179,3118, 2155,2921", "alt": "Plot - 9" },
  { "id": "plot-10", "coords": "2158,2919, 2187,3117, 2377,3096, 2339,2896", "alt": "Plot - 10" },
  { "id": "plot-11", "coords": "2378,2888, 2411,3096, 2631,3069, 2589,2859", "alt": "Plot - 11" },
  { "id": "plot-12", "coords": "2592,2859, 2639,3066, 2762,3055, 2702,2845", "alt": "Plot - 12" },
  { "id": "plot-13", "coords": "2704,2841, 2764,3049, 2948,3037, 2888,2815", "alt": "Plot - 13" },
  { "id": "plot-14", "coords": "2894,2816, 2950,3030, 3075,3023, 3034,2802", "alt": "Plot - 14" },
  { "id": "plot-15", "coords": "2174,3157, 2190,3362, 2421,3350, 2383,3131", "alt": "Plot - 15" },
  { "id": "plot-16", "coords": "2000,3173, 2016,3376, 2187,3362, 2166,3153", "alt": "Plot - 16" },
  { "id": "plot-17", "coords": "1843,3191, 1863,3385, 2013,3375, 1994,3172", "alt": "Plot - 17" },
  { "id": "plot-18", "coords": "1864,3393, 1886,3603, 2048,3599, 2014,3379", "alt": "Plot - 18" },
  { "id": "plot-19", "coords": "2016,3379, 2052,3600, 2220,3599, 2192,3368", "alt": "Plot - 19" },
  { "id": "plot-20", "coords": "2193,3368, 2222,3598, 2459,3589, 2420,3354", "alt": "Plot - 20" },
  { "id": "plot-21", "coords": "2452,3321, 2501,3585, 2667,3580, 2635,3312", "alt": "Plot - 21" },
  { "id": "plot-22", "coords": "2641,3309, 2671,3580, 2829,3578, 2804,3297", "alt": "Plot - 22" },
  { "id": "plot-23", "coords": "2806,3296, 2833,3576, 3009,3573, 2972,3290", "alt": "Plot - 23" },
  { "id": "plot-24", "coords": "2976,3286, 3013,3571, 3161,3567, 3117,3277", "alt": "Plot - 24" },
  { "id": "plot-25", "coords": "2031,2547, 2051,2677, 2299,2641, 2278,2507", "alt": "Plot - 25" },
  { "id": "plot-26", "coords": "2004,2389, 2027,2540, 2280,2504, 2262,2369", "alt": "Plot - 26" },
  { "id": "plot-27", "coords": "1983,2251, 2004,2385, 2259,2364, 2239,2228", "alt": "Plot - 27" },
  { "id": "plot-28", "coords": "1964,2134, 1982,2247, 2238,2223, 2222,2100", "alt": "Plot - 28" },
  { "id": "plot-29", "coords": "1940,2000, 1960,2130, 2223,2096, 2207,1966", "alt": "Plot - 29" },
  { "id": "plot-30", "coords": "1916,1865, 1939,1998, 2206,1962, 2188,1828", "alt": "Plot - 30" },
  { "id": "plot-31", "coords": "1898,1737, 1915,1859, 2184,1823, 2168,1695", "alt": "Plot - 31" },
  { "id": "plot-32", "coords": "2205,1693, 2222,1820, 2456,1796, 2433,1667", "alt": "Plot - 32" },
  { "id": "plot-33", "coords": "2221,1823, 2239,1957, 2472,1928, 2454,1801", "alt": "Plot - 33" },
  { "id": "plot-34", "coords": "2241,1960, 2257,2092, 2491,2062, 2471,1932", "alt": "Plot - 34" },
  { "id": "plot-35", "coords": "2259,2095, 2276,2226, 2512,2216, 2486,2070", "alt": "Plot - 35" },
  { "id": "plot-36", "coords": "2276,2232, 2295,2366, 2531,2354, 2510,2221", "alt": "Plot - 36" },
  { "id": "plot-37", "coords": "2299,2371, 2315,2504, 2543,2468, 2526,2358", "alt": "Plot - 37" },
  { "id": "plot-38", "coords": "2315,2508, 2333,2636, 2566,2605, 2542,2472", "alt": "Plot - 38" },
  { "id": "plot-39", "coords": "2476,1928, 2489,2066, 2791,2055, 2769,1931", "alt": "Plot - 39" },
  { "id": "plot-40", "coords": "2489,2068, 2513,2215, 2815,2197, 2791,2057", "alt": "Plot - 40" },
  { "id": "plot-41", "coords": "2514,2219, 2532,2350, 2842,2337, 2815,2203", "alt": "Plot - 41" },
  { "id": "plot-42", "coords": "2531,2358, 2553,2506, 2866,2470, 2842,2342", "alt": "Plot - 42" },
  { "id": "plot-43", "coords": "2553,2510, 2569,2603, 2884,2561, 2868,2475", "alt": "Plot - 43" },
  { "id": "plot-44", "coords": "2807,1931, 2826,2060, 3162,2052, 3152,1960, 3107,1933", "alt": "Plot - 44" },
  { "id": "plot-45", "coords": "2830,2065, 2851,2195, 3179,2177, 3163,2057", "alt": "Plot - 45" },
  { "id": "plot-46", "coords": "2853,2199, 2878,2335, 3197,2290, 3180,2179", "alt": "Plot - 46" },
  { "id": "plot-47", "coords": "2878,2340, 2902,2462, 3215,2428, 3195,2297", "alt": "Plot - 47" },
  { "id": "plot-48", "coords": "2900,2466, 2919,2554, 3007,2544, 3012,2552, 3227,2527, 3211,2431", "alt": "Plot - 48" },
{ "id": "plot-49", "coords": "2840,3087, 2866,3252, 3112,3239, 3081,3059", "alt": "Plot - 49" }];

const MapAreas = ({
  imageDimensions,
  hoveredPlotId,
  setHoveredPlotId,
  onPlotClick,
}) => {
  const polygons = useMemo(() => {
    const toPoints = (coords) => {
      const numbers = String(coords)
        .split(",")
        .map((item) => Number(item.trim()))
        .filter((num) => !Number.isNaN(num));

      const pairs = [];
      for (let i = 0; i < numbers.length; i += 2) {
        if (numbers[i] != null && numbers[i + 1] != null) {
          pairs.push(`${numbers[i]},${numbers[i + 1]}`);
        }
      }

      return pairs.join(" ");
    };

    return plotCoordinates.map((plot) => ({
      ...plot,
      points: toPoints(plot.coords),
    }));
  }, []);

  const width = imageDimensions?.width || 1;
  const height = imageDimensions?.height || 1;

  return (
    <svg
      className="map-svg-overlay"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      aria-label="Interactive plot map"
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        display: "block",
        overflow: "visible",
        pointerEvents: "none",
        zIndex: 30,
      }}
    >
      {polygons.map((plot) => (
        <polygon
          key={plot.id}
          points={plot.points}
          className={`map-plot ${hoveredPlotId === plot.id ? "is-hovered" : ""}`}
          style={{
            pointerEvents: "all",
            cursor: "pointer",
          }}
          onMouseEnter={() => setHoveredPlotId?.(plot.id)}
          onMouseLeave={() => setHoveredPlotId?.(null)}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onPlotClick?.(plot.id);
          }}
        >
          <title>{plot.alt}</title>
        </polygon>
      ))}
    </svg>
  );
};

export default MapAreas;
